import ReactFullpage from "@fullpage/react-fullpage";
import EndSection from "../../Sections/EndSection";
import "./index.less"
import "./indexMobile.less"
import {useEffect, useState} from "react";
import {Col, Row} from "antd";
import MoreButton from "../../MoreButton";
import VideoSection from "../../Sections/VideoSection";
import {isMobile} from "react-device-detect";

const BrandOriginPageContent = () => {
    return <>

        {!isMobile && <div className={"section brandOriginContainer"}>
            <div className={"topBg"}></div>
            <div className={"cc-topBg2"}></div>

            <img src="/HomeLogoTemp.png" className="rightIcon" draggable="false"/>

            <div className={"topBg topBg-2-p"}></div>
            <div className={"cc-topBg2 cc-topBg2-p"}></div>

            <div className={"topBgMask"}></div>

            <div className={"titleContainer"}>
                <div className={"desc"}>
                    Brand Origin
                </div>
                <div className={"title"}>
                    品牌起源
                </div>
            </div>

            <Row className={"deleteScroll"} justify={"center"}>
                <Col>
                    <div className={"brandCulture-content bo-container"}>
                        <Row justify={"center"}>
                            <Col>
                                <div className={"card b-image-card"} style={{
                                    backgroundImage: `url(/img_1.png)`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    backgroundRepeat: 'no-repeat'
                                }}>

                                </div>
                            </Col>

                            <Col>
                                <div className={"card b-desc-card"} style={{
                                    marginTop: "-11px",
                                    backgroundColor: "#F3F3F3"
                                }}>
                                    <div className={"deleteTransform"}>
                                        <div className={"tag"}>
                                            品牌简介
                                        </div>
                                        <Row justify={"center"} style={{paddingTop: "12px", paddingLeft: "24px"}}>
                                            <Col className={"card2-Title-su"}>
                                                中国第一家潮流集合店
                                            </Col>
                                        </Row>


                                        <Row style={{marginTop: "24px", marginLeft: "24px"}}>
                                            <Col className={"card2-text"} style={{paddingRight: "48px"}}>
                                                2006年的上海新乐路1200PFM，概念店总共1000平方米，以全球街头文化的聚集地以音乐和街头艺术为主题。
                                                将40多个来自世界各地的街头品牌结合服装、球鞋、饰品以及艺术展现在大家面前。

                                                是当时国内最大的潮流概念店，与当下的潮流文化，青年文化相融合，举办青年摄影展和涂鸦艺术展，引起了当时很多关注，还有很多人从外地慕名而来。
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            </Col>

                            <Col>
                                <Row>
                                    <Col>
                                        <div className={"card bo-image-card"} style={{
                                            marginTop: "-11px",
                                            backgroundImage: `url(/img_2.png)`,
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center',
                                            backgroundRepeat: 'no-repeat'
                                        }}>

                                        </div>
                                    </Col>
                                    <Col>
                                        <Row>
                                            <Col>
                                                <div className={"card bo-image-card3"}
                                                     style={{
                                                         marginTop: "-8px",
                                                         backgroundImage: `url(/img_3.png)`,
                                                         backgroundSize: 'cover',
                                                         backgroundPosition: 'center',
                                                         backgroundRepeat: 'no-repeat'
                                                     }}>

                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <div className={"card bo-image-card3"}
                                                     style={{
                                                         marginTop: "-11px",
                                                         backgroundImage: `url(/img_4.png)`,
                                                         backgroundSize: 'cover',
                                                         backgroundPosition: 'center',
                                                         backgroundRepeat: 'no-repeat'
                                                     }}>

                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>

                                <Row style={{marginTop: "-11px"}}>
                                    <Col style={{marginLeft: "11px"}}>
                                        <Row style={{paddingBottom: "20px", paddingTop: "14px"}}>
                                            <Col className={"titleText"}>
                                                Source 文化构成
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col>
                                                <div className={"card-2 card3-text"}
                                                     style={{width: "265px", height: "63px"}}>
                                                    Multi-Band
                                                </div>
                                            </Col>
                                            <Col style={{marginLeft: "30px", marginTop: "-11px"}}>
                                                <div className={"card-2 card3-text"}
                                                     style={{width: "285px", height: "63px"}}>
                                                    International
                                                </div>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col style={{marginTop: "11px"}}>
                                                <div className={"card-2 card3-text"}
                                                     style={{width: "265px", height: "63px"}}>
                                                    Authentic
                                                </div>
                                            </Col>
                                            <Col style={{marginLeft: "30px"}}>
                                                <div className={"card-2 card3-text"}
                                                     style={{width: "285px", height: "63px"}}>
                                                    Innovative
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>
        </div>}


        {isMobile && <div className={"section fp-auto-height brandOriginContainer-mobile"}>
            <div className={"topBg"}></div>
            <div className={"cc-topBg2"}></div>

            <img src="/HomeLogoTemp.png" className="rightIcon rightIcon-mobile" draggable="false"/>

            <div className={"topBg topBg-2-p"}></div>
            <div className={"cc-topBg2 cc-topBg2-p"}></div>

            <div className={"topBgMask"}></div>

            <div className={"titleContainer titleContainer-mobile"}>
                <div className={"desc"}>
                    Brand Origin
                </div>
                <div className={"title"}>
                    品牌起源
                </div>
            </div>

            <div className={"container1"} style={{marginTop:"300px"}}>
                <div className={"imgContainer"}>
                    <div className={"container-1-card"} style={{
                        backgroundImage: `url(/img_3.png)`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat'
                    }}></div>
                    <div className={"container-1-card"} style={{
                        backgroundImage: `url(/img_4.png)`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat'
                    }}></div>
                </div>
                <div className={"textContainer"}>
                    <div className={"tag"}>
                        品牌简介
                    </div>

                    <div className={"title"}>
                        中国第一家潮流集合店
                    </div>

                    <div className={"text"}>
                        2006年的上海新乐路1200PFM，概念店总共1000平方米，以全球街头文化的聚集地以音乐和街头艺术为主题。
                        将40多个来自世界各地的街头品牌结合服装、球鞋、饰品以及艺术展现在大家面前。
                        <br/>
                        <br/>
                        是当时国内最大的潮流概念店，与当下的潮流文化，青年文化相融合，举办青年摄影展和涂鸦艺术展，引起了当时很多关注，还有很多人从外地慕名而来。
                    </div>
                </div>
            </div>

            <div className={"container-2"}>
                <div className={"title"}>
                    Source 文化构成
                </div>
                <div className={"tagContainer"}>
                    <div className={"row"}>
                        <div className={"card-2-mobile b-tagCard-mobile card3-text-mobile"}>
                            Multi-Band
                        </div>
                        <div className={"card-2-mobile b-tagCard-mobile card3-text-mobile"}>
                            International
                        </div>
                    </div>

                    <div className={"row"}>
                        <div className={"card-2-mobile b-tagCard-mobile card3-text-mobile"}>
                            Authentic
                        </div>
                        <div className={"card-2-mobile b-tagCard-mobile card3-text-mobile"}>
                            Innovative
                        </div>
                    </div>
                </div>
            </div>
        </div>}
    </>
}

const TimeLineItem = ({year, title, desc}) => {
    return <>
        <div style={{textAlign: "center", marginTop: "24px"}}>
            <svg width="6" height="47" viewBox="0 0 6 47" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 0.701261L0.113249 3.58801L3 6.47476L5.88675 3.58801L3 0.701261ZM3 46.4748L5.88675 43.588L3 40.7013L0.113249 43.588L3 46.4748ZM2.5 3.58801V43.588H3.5V3.58801H2.5Z"
                    fill="black" fill-opacity="0.24"/>
            </svg>
        </div>

        <div className={"title-text"}>
            {year}
        </div>

        <div className={"title-text"} style={{fontSize: "21px", marginTop: "12px"}}>
            {title}
        </div>

        <div className={"desc-text"} style={{marginTop: "12px",...(isMobile ? {
            paddingLeft: "48px",
            paddingRight: "48px"
            }:{})}}>
            {desc}
        </div>
    </>
}

const BrandOriginTimelineContent = () => {
    return <div className={"section fp-auto-height brandOriginTimeline-bg"}>
        <div className={"tag"}>
            <svg width="294" height="85" viewBox="0 0 294 85" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M259.66 67.5868C253.959 67.5868 248.252 67.5868 242.55 67.5868C241.358 67.5868 241.278 67.6986 241.736 68.7952C242.614 70.898 244.233 72.2928 246.25 73.1872C249.785 74.7576 253.442 74.9599 257.147 73.8473C258.537 73.4267 259.761 72.6601 260.805 71.654C261.305 71.1695 261.843 70.9672 262.54 70.9726C266.879 70.9939 271.212 70.9832 275.551 70.9939C275.907 70.9939 276.387 70.8182 276.589 71.1962C276.786 71.5582 276.424 71.8935 276.232 72.2023C272.777 77.7122 267.837 81.3428 261.656 83.1368C252.755 85.7187 244.201 84.7019 236.226 79.8895C232.212 77.4673 229.092 74.1294 227.501 69.6417C225.116 62.9074 226.91 56.9983 231.504 51.8451C235.699 47.1445 241.14 44.6318 247.294 43.7055C254.965 42.5503 262.301 43.5884 268.928 47.8312C274.981 51.7067 278.468 57.19 278.575 64.5311C278.617 67.5655 278.527 67.5975 275.535 67.5975C270.243 67.5868 264.952 67.5868 259.66 67.5868ZM252.537 59.5323C255.886 59.5323 259.229 59.5163 262.577 59.543C263.434 59.5483 263.504 59.2608 263.158 58.5847C262.471 57.2485 261.481 56.1838 260.251 55.3374C256.104 52.4786 248.944 52.484 244.797 55.3427C243.684 56.1093 242.763 57.0569 242.092 58.2334C241.432 59.4046 241.502 59.527 242.806 59.527C246.048 59.5376 249.29 59.5376 252.537 59.5323Z"
                    fill="black"/>
                <path
                    d="M66.8673 43.338C74.2138 43.3646 80.2453 44.6316 85.6115 48.2783C89.1835 50.7058 91.8613 53.8733 93.3572 57.9405C95.7687 64.499 94.2728 70.3709 89.9128 75.5879C86.0906 80.1555 80.996 82.5884 75.2306 83.6744C67.9906 85.0425 60.8784 84.6539 54.0483 81.7047C49.502 79.7403 45.8554 76.6793 43.4225 72.314C39.6907 65.6276 40.6862 57.7541 45.9139 51.9036C50.1674 47.1443 55.6453 44.7913 61.8153 43.7852C63.8063 43.4605 65.8133 43.2954 66.8673 43.338ZM68.1077 54.3151C65.414 54.3577 63.0876 54.906 60.9263 56.1358C54.9692 59.5109 54.5221 67.0277 60.0532 71.047C64.4984 74.273 71.4402 74.1985 75.8162 70.8766C80.4955 67.3258 80.767 61.2783 76.3805 57.3602C73.9742 55.2095 71.041 54.4269 68.1077 54.3151Z"
                    fill="black"/>
                <path
                    d="M128.281 79.5967C125.375 83.1581 121.504 84.2068 117.272 84.4091C113.381 84.5954 109.548 84.2441 105.912 82.7429C101.642 80.9808 98.4802 78.0741 97.0162 73.5811C96.4945 71.984 96.3987 70.2965 96.3933 68.6249C96.3667 61.0548 96.3933 53.4794 96.3614 45.9094C96.3561 44.882 96.6808 44.5572 97.7189 44.5732C101.781 44.6264 105.848 44.5945 109.91 44.5945C111.395 44.5945 111.4 44.5998 111.4 46.0478C111.4 52.7661 111.4 59.4844 111.4 66.208C111.4 66.6498 111.384 67.097 111.432 67.5389C111.794 71.0098 113.413 72.7187 116.873 73.3096C118.3 73.5545 119.732 73.5864 121.153 73.3415C125.401 72.6015 127.451 70.1793 127.461 65.8779C127.477 59.33 127.467 52.7821 127.467 46.2288C127.467 44.5998 127.467 44.5998 129.09 44.5998C133.152 44.5998 137.219 44.6264 141.281 44.5838C142.234 44.5732 142.522 44.9086 142.522 45.8242C142.5 57.866 142.5 69.9025 142.527 81.9443C142.527 82.9292 142.197 83.2379 141.223 83.2273C137.331 83.1847 133.434 83.1794 129.543 83.2273C128.553 83.2379 128.185 82.9132 128.265 81.9337C128.334 81.1564 128.281 80.3739 128.281 79.5967Z"
                    fill="black"/>
                <path
                    d="M217.156 59.1757C215.005 59.1757 212.854 59.1704 210.703 59.1757C210.176 59.1757 209.708 59.1171 209.373 58.6114C207.131 55.2416 203.799 53.932 199.929 53.751C196.367 53.5807 193.04 54.2408 190.4 56.8759C185.965 61.2944 187.11 68.6143 192.726 71.3772C196.921 73.4374 201.228 73.4055 205.497 71.5422C207.03 70.8768 208.233 69.7482 209.239 68.428C209.607 67.9435 210.033 67.7466 210.629 67.7466C214.968 67.7625 219.301 67.7466 223.64 67.7572C224.742 67.7625 224.864 67.9382 224.475 68.9656C222.793 73.3788 219.78 76.6954 215.83 79.1708C209.825 82.9399 203.224 84.1856 196.218 83.6479C190.943 83.2433 186.024 81.7527 181.626 78.7716C177.415 75.9128 174.338 72.1651 173.183 67.1184C171.799 61.0655 173.465 55.758 177.591 51.233C181.791 46.6281 187.189 44.1953 193.264 43.2796C201.659 42.0126 209.607 43.2796 216.756 48.1081C220.233 50.4557 222.83 53.5753 224.3 57.552C224.869 59.0905 224.805 59.1704 223.203 59.1757C221.185 59.1757 219.173 59.1757 217.156 59.1757Z"
                    fill="black"/>
                <path
                    d="M7.44686 71.5901C9.56563 71.5901 11.6791 71.5848 13.7978 71.5955C14.229 71.5955 14.7028 71.5209 14.9051 72.0906C15.6824 74.2519 17.503 74.8322 19.5206 75.0611C20.8302 75.2101 22.1132 74.9972 23.3323 74.4861C24.3065 74.0709 25.1476 73.5013 25.2434 72.3088C25.3499 71.0099 24.562 70.2912 23.5346 69.7695C21.9748 68.9763 20.2819 68.5451 18.6156 68.0447C15.2511 67.0332 11.8228 66.2347 8.52221 65.0049C7.33507 64.5631 6.21713 63.9775 5.14178 63.3121C-1.09207 59.4632 -0.341453 53.2187 3.3584 49.2154C5.90304 46.4578 9.18765 44.9725 12.7651 44.1261C18.8019 42.694 24.7696 42.9389 30.551 45.2813C34.6288 46.9316 37.5354 49.7477 38.5522 54.1982C38.8503 55.5078 38.7811 55.5929 37.4343 55.5929C33.4044 55.5929 29.3745 55.5823 25.3446 55.6036C24.5993 55.6089 24.0563 55.5397 23.8327 54.6507C23.6304 53.8415 22.9383 53.3784 22.1611 53.1228C20.6279 52.6224 19.0734 52.5798 17.5296 53.0483C16.5235 53.3571 15.6983 53.9533 15.5652 55.0499C15.4428 56.0667 16.2041 56.6577 16.9813 57.1208C19.0415 58.3505 21.3572 58.8243 23.6517 59.3407C26.915 60.07 30.1943 60.7514 33.2819 62.0876C36.0768 63.2961 38.5256 64.9251 39.6648 67.9276C41.198 71.9628 39.8565 76.557 36.327 79.5382C34.2029 81.3322 31.7647 82.53 29.1083 83.2753C22.1558 85.2237 15.2565 85.0853 8.54883 82.3064C4.26872 80.5283 1.18107 77.5472 0.121694 72.8358C-0.133836 71.6913 -0.0646299 71.5955 1.0959 71.5901C3.21466 71.5848 5.3281 71.5901 7.44686 71.5901Z"
                    fill="black"/>
                <path
                    d="M161.594 48.1878C164.623 44.3762 168.723 43.4392 173.173 43.2848C173.828 43.2635 174.105 43.5084 174.099 44.1685C174.089 47.5117 174.083 50.8549 174.099 54.1927C174.105 54.9327 173.732 55.135 173.082 55.1297C171.267 55.119 169.468 55.316 167.706 55.7472C163.979 56.6629 162.435 58.6485 162.43 62.4548C162.43 68.9016 162.43 75.3484 162.43 81.7899C162.43 83.1847 162.425 83.19 160.998 83.19C156.899 83.19 152.805 83.1634 148.706 83.2113C147.721 83.2219 147.396 82.9078 147.396 81.9283C147.418 69.8918 147.418 57.85 147.402 45.8135C147.402 44.9085 147.668 44.5518 148.632 44.5625C152.555 44.6104 156.484 44.5997 160.412 44.5678C161.296 44.5625 161.664 44.8446 161.6 45.7443C161.552 46.5588 161.594 47.3733 161.594 48.1878Z"
                    fill="black"/>
                <path
                    d="M286.118 51.0786C283.089 51.1105 280.837 50.3652 279.022 48.5605C276.648 46.2022 276.664 42.9229 279.012 40.5486C282.238 37.2853 288.53 37.1309 291.926 40.2292C295.067 43.0933 294.583 47.4373 290.872 49.6838C289.233 50.6793 287.726 51.0786 286.118 51.0786ZM284.931 49.5134C287.529 49.5294 289.169 48.9758 290.473 47.8578C292.464 46.1543 292.597 43.402 290.782 41.5281C288.093 38.7546 282.669 38.9569 280.193 41.9221C278.884 43.4872 278.878 45.6113 280.193 47.1764C281.588 48.832 283.441 49.4602 284.931 49.5134Z"
                    fill="black"/>
                <path
                    d="M285.579 48.8161C284.855 48.8481 284.147 48.7682 283.455 48.5713C282.789 48.3849 282.172 48.0921 281.709 47.5598C281.288 47.0753 280.804 46.5217 281.277 45.8669C281.607 45.4144 283.189 45.7178 283.567 46.2183C284.259 47.1392 285.813 47.5012 286.883 46.9902C287.139 46.8677 287.378 46.7133 287.394 46.4046C287.41 46.0532 287.181 45.819 286.867 45.7338C286.116 45.5209 285.355 45.3345 284.594 45.1535C283.865 44.9779 283.119 44.8501 282.465 44.4562C281.139 43.663 281.006 42.1191 282.166 41.1236C283.689 39.8141 287.282 39.7821 288.8 41.1023C289.311 41.5442 289.832 42.0978 289.444 42.8485C289.225 43.2637 287.415 43.0827 287.112 42.6142C286.479 41.64 285.558 41.7784 284.642 41.8956C284.301 41.9381 283.982 42.1351 283.971 42.5503C283.96 42.9336 284.264 43.0774 284.567 43.1519C285.494 43.3702 286.425 43.5671 287.362 43.7694C289.018 44.1261 289.965 44.9513 289.997 46.0639C290.035 47.3149 289.082 48.2465 287.405 48.6564C286.798 48.8055 286.191 48.8002 285.579 48.8161Z"
                    fill="black"/>
                <path
                    d="M126.625 8.84L125.967 7.678C128.375 6.376 130.139 4.556 131.371 2.428L132.547 3.044C132.407 3.296 132.267 3.534 132.113 3.772C133.079 5.312 134.731 6.642 136.397 7.636L135.795 8.882C134.045 7.846 132.449 6.46 131.385 4.794C130.097 6.446 128.445 7.846 126.625 8.84ZM135.179 14.776L135.053 16.008H125.715L125.855 14.776H127.339L127.927 9.19H129.159L128.557 14.776H129.999L130.811 7.076H132.099L131.805 9.89H134.227L134.101 11.122H131.665L131.287 14.776H135.179ZM146.18 14.51L146.04 15.798H137.164L137.304 14.51H139.992L140.272 11.78L139.11 12.102C138.718 9.68 138.368 7.216 138.144 5.074L139.334 4.85C139.502 6.992 139.894 9.106 140.286 11.752L141.252 2.568H142.47L141.21 14.51H142.358L143.618 2.568H144.836L143.576 14.51H146.18ZM147.202 5.032C146.754 7.3 146.166 9.778 145.214 12.2L144.136 11.71C144.976 9.54 145.62 7.118 146.04 4.836L147.202 5.032ZM158.735 3.128L158.609 4.318H151.525L151.119 8.252C150.755 11.612 150.237 14.132 149.313 16.274L148.179 15.798C149.019 13.81 149.537 11.458 149.873 8.238L150.405 3.128H158.735ZM151.259 16.134L150.349 15.28C151.917 13.53 152.799 11.374 153.303 8.518H151.707L151.833 7.3H153.485C153.499 7.132 153.527 6.978 153.541 6.81L153.751 4.976H154.955L154.745 6.824C154.731 6.978 154.703 7.146 154.689 7.3H156.677C157.363 7.3 157.755 7.762 157.671 8.448L156.985 14.02C156.845 15.21 156.271 16.134 155.165 16.134C154.115 16.134 153.485 15.392 153.345 14.244L154.381 14.062C154.479 14.636 154.703 14.986 155.067 14.986C155.431 14.986 155.669 14.692 155.767 13.908L156.439 8.518H154.507C153.975 11.57 152.981 14.174 151.259 16.134ZM160.161 13.544L159.461 12.928C160.273 11.374 160.889 9.68 161.323 7.538H160.399L160.525 6.362H161.799L161.995 4.458C161.715 4.528 161.435 4.598 161.169 4.668L160.819 3.534C161.799 3.31 162.905 2.988 163.745 2.652L164.165 3.716C163.857 3.842 163.535 3.954 163.213 4.066L162.975 6.362H163.885L163.759 7.538H162.807L162.667 8.868C163.059 9.358 163.409 9.848 163.815 10.464L163.045 11.206C162.863 10.87 162.681 10.576 162.513 10.31L161.883 16.12H160.735L161.561 9.302C161.197 10.856 160.749 12.242 160.161 13.544ZM169.191 4.164L168.813 7.594H164.375L164.865 3.03H168.155C168.967 3.03 169.261 3.492 169.191 4.164ZM165.691 6.404H167.749L167.987 4.234H165.915L165.691 6.404ZM168.799 14.65L168.673 15.826H162.765L162.891 14.65H165.299L165.495 12.732H163.535L163.661 11.556H165.621L165.803 9.834H163.703L163.829 8.658H169.121L168.995 9.834H166.979L166.797 11.556H168.701L168.575 12.732H166.671L166.475 14.65H168.799Z"
                    fill="#E35113"/>
                <rect x="113.5" y="0.5" width="68" height="18" rx="3.5" stroke="#E35113"/>
            </svg>
        </div>

        <TimeLineItem year={"2003"} title={"MISHKA 成立"}
                      desc={"2003年，Greg Rivera与Mikhail在纽约Brooklyn成立街头文化潮牌Mishka，进入中国市场在Source渠道销售"}/>

        <TimeLineItem year={"2006"} title={"Source 成立"}
                      desc={"中国第一个潮牌集合店，集结全球40多个潮流品牌/鞋塔/限量发行/潮流地标/派对据点。Source整合设计、生产和销售资源转型成为一家全产业链的品牌公司"}/>

        <TimeLineItem year={"2014"} title={"中国 Lisencing"} desc={"Mishka第一家中国专卖店落地，潮牌品牌化"}/>

        <TimeLineItem year={"2017"} title={"Source 收购 Mishka 全球"} desc={""}/>

        <TimeLineItem year={"2019"} title={"完成初期渠道搭建"}
                      desc={"Mishka 线下完成超过70家门店运营，线上已在超过5个渠道铺开，寻求进一步扩张"}/>
        <TimeLineItem year={"至今"} title={"蓄势待发"}
                      desc={"带领RIBNDIP、CHINATOWN、PLEASURE等其他品牌在成都、长沙等地开设多品牌店铺"}/>

        <div style={{marginTop: "80px"}}></div>
    </div>
}


export default () => {

    const [fullPageData, setFullPageData] = useState(null);

    useEffect(() => {
        const watermark = document.querySelector(".fp-watermark");
        watermark && watermark.remove();
    }, [])

    return <div>
        <ReactFullpage
            licenseKey={'YOUR_KEY_HERE'}
            scrollingSpeed={1000}
            loopTop={false}
            loopBottom={false}
            anchors={['bo1', 'bo2', 'bo3', 'bo4']}
            scrollOverflowReset={true}
            onLeave={(origin, destination, direction) => {
                setFullPageData({origin, destination, direction})
            }}
            render={({state, fullpageApi}) => {
                return (
                    <ReactFullpage.Wrapper>
                        <BrandOriginPageContent/>
                        <VideoSection data={fullPageData} type={"bo2"}/>
                        <BrandOriginTimelineContent/>
                        <EndSection/>
                    </ReactFullpage.Wrapper>
                );
            }}
        />
    </div>
}